<template>
  <VueperSlides class="carousel" :touchable="false" fixedHeight>
    <VueperSlide
      v-for="offer in offers"
      :key="offer.id"
      @click="onClick(offer)"
      style="cursor: pointer"
    >
      <template v-slot:content>
        <div class="desktopContent" :style="{'background-image': `url(${offer.carouselImage || '/img/partner_offer_carousel_placeholder.png'})`}"></div>
        <OfferCard class="mobileContent" :offer="offer" :context="context"/>
      </template>
    </VueperSlide>
  </VueperSlides>
</template>

<script lang="ts" setup>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

import { PartnerOffer } from '@/features/partnerOffers/model';
import { displayModalOffer, displayedModalContext, displayedModalOffer } from './state';
import { logInteraction } from './api';
import OfferCard from './OfferCard.vue';
import { InteractionType } from '@/features/analytics/api';

const props = defineProps<{
  offers: PartnerOffer[],
  context: string,
}>();

const onClick = (offer: PartnerOffer) => {
  displayModalOffer(props.context, offer);
  logInteraction(props.context, offer, InteractionType.CLICK, "carousel");
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vueperslides--fixed-height { 
  height: min(30vw, 500px);
}

.desktopContent {
  width: 100%;
  height: 100%;

  background-size: cover;
  background-position: center;
}

.mobileContent {
  display: none;
}

@media screen and (max-width: 750px) {
  .vueperslides--fixed-height { 
    height: clamp(615px, 150vw, 650px);
  }

  .desktopContent {
    display: none;
  }

  .mobileContent {
    display: flex;
  }
}
</style>

<style>
@media screen and (max-width: 750px) {
  .vueperslides__arrows {
    color: #666;
  }

  .vueperslides__bullet .default {
    border-color: #666;
  }
}
</style>